import Button, { ButtonProps } from "@mui/material/Button";
import React from "react";

const StyledButton: React.FC<ButtonProps> = ({ children, size, variant = "contained", sx, ...props }) => (
  <Button
    {...props}
    variant={variant}
    size={size}
    sx={{
      ...sx,
      ...(variant === "contained"
        ? {
          background: (theme) => theme.palette.primary.main,
          color: "#fff",
          borderRadius: "8px",
          boxShadow: "0px 2px 6px 0px #0000000F, -2px 2px 3px 0px #8BCAAA inset, 2px 2px 2px 0px #8BCAAA inset",
          border: "1px solid #399069",
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "500",
          padding: size === "medium" ? "7px 31px" : "5px 31px",
          textTransform: "none",
          "&:hover": {
            background: (theme) => theme.palette.primary.main,
            boxShadow: "0px 2px 6px 0px #0000000F, -2px 2px 3px 0px #8BCAAA inset, 2px 2px 2px 0px #8BCAAA inset",
            border: "1px solid #399069",
          },
          "& .MuiButton-startIcon": {
            marginRight: "6px",
          },
        }
        : {
          color: "#596375",
          borderRadius: "8px",
          padding: size === "medium" ? "7px 11px" : "5px 11px",
          boxShadow: "0 1px 2px 0 rgba(9, 25, 72, 0.06)",
          border: "1px solid #E0E4EE",
          textTransform: "none",
          fontSize: "14px",
          lineHeight: "20px",
          "&:hover": {
            color: "#596375",
            boxShadow: "0 1px 2px 0 rgba(9, 25, 72, 0.06)",
            border: "1px solid #E0E4EE",
          },
          "& .MuiButton-startIcon": {
            marginRight: "6px",
          },
        }),
    }}
  >
    {children}
  </Button>
);

export default StyledButton; 